import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import {mapApiToForm,mapFormToApi} from "../../../../redux/mappers/Import/CreateNewJob/InvoiceOtherCharges.js"

export const invoiceotherchargesApi = createApi({
  reducerPath: "invoiceotherchargesApi",
  baseQuery,
  tagTypes: ["invoiceOtherInfo"],
  endpoints: (builder) => ({
    // 🔹 Get single invoice by Id
    getInvoiceOtherChargesById: builder.query({
      query: ({ id, subId }) => `import/invoice/otherCharges/${id}/${subId}`,

      transformResponse: (response) => mapApiToForm(response?.data),
      providesTags: ["invoiceOtherInfo"],
    }),
    // 🔹 Update invoiceBuyer by Id
    updateInvoiceOtherCharges: builder.mutation({
      query: ({ id, dataId, ...data }) => ({
        url: `import/invoice/otherCharges/${id}/${dataId}`,
        method: "PUT", // ✅ should be PUT, not GET
        body: {
          otherCharges: mapFormToApi(data),
        },        headers: {
          "X-Request-Id": `${Date.now()}`,
        },
      }),
      invalidatesTags: ["invoiceOtherInfo"],
    }),
  }),
});

export const {
  useGetInvoiceOtherChargesByMasterIdQuery,
  useLazyGetInvoiceOtherChargesByIdQuery,
  useUpdateInvoiceOtherChargesMutation,
} = invoiceotherchargesApi;
